(function() {

  'use strict';

  $('.mh-servizi').matchHeight({
    byRow: false
  });

  var slider_lavori = $('.slider-lavori');
  var slider_man_prog = $('.slider-man-prog');
var slider_galleria = $('.slider-galleria');
      
  slider_galleria.owlCarousel({
    // center:true,
    loop:false,
    interval: 2000,
    pause: "false",
    smartSpeed: 1000,
    items:3,
    dots: true,
    autoplay:false,
    autoplayTimeout:5000,
    autoplayHoverPause:false,
    nav: false,
    responsiveClass:true,
    responsive:{
      0:{
        stagePadding: 50,
        margin: 20,
        dots: false,
        items:1
      },
      576:{
        stagePadding: 50,
        margin: 20,
        dots: false,
        items:2
      },
      992:{
        stagePadding: 50,
        margin: 20,
        items:2
      },
      1200 : {
        stagePadding: 50,
        margin: 20,
        items: 3
      }
    }
  });

  slider_lavori.owlCarousel({
    loop:true,
    rtl: true,
    interval: 2000,
    pause: "false",
    smartSpeed: 1000,
    items:1.3,
    dots: false,
    autoplay:false,
    autoplayTimeout:5000,
    autoplayHoverPause:false,
    nav: false,
    responsiveClass:true,
    responsive:{
        0:{
          margin: 20
        },
        992:{
          margin: 100
        }
    }
  });

  slider_man_prog.owlCarousel({
    loop:true,
    interval: 2000,
    pause: "false",
    smartSpeed: 1000,
    items:2,
    dots: false,
    autoplay:false,
    autoplayTimeout:5000,
    autoplayHoverPause:false,
    nav: false,
    margin: 20,
    responsiveClass:true,
    responsive:{
        0:{
          items:1.2
        },
        576:{
          items:1.2
        },
        992:{
          items:2
        },
        1200 : {
          items: 2
        }
    }
  });

}());
